import React from "react";
import { useTranslation } from "react-i18next";
import { Dialog, DialogTitle, DialogContent, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const ValidationErrorModal = ({ open, onClose, errors, title }) => {
  const { t } = useTranslation();

  const normalizedGroups = Array.isArray(errors) ? errors : [];

  const flattenedErrors = normalizedGroups.flatMap((group) => {
    if (Array.isArray(group?.errors) && group.errors.length > 0) {
      return group.errors.map((error) => ({
        ...error,
        error_date: group.error_date,
      }));
    }

    if (group?.error_message || group?.value_string || group?.error_code) {
      return [group];
    }

    return [];
  });

  if (!open || flattenedErrors.length === 0) {
    return null;
  }

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      PaperProps={{
        style: {
          borderRadius: "12px",
        },
      }}
    >
      <DialogTitle
        style={{
          // backgroundColor: "#FEF3C7",
          borderBottom: "2px solid #FDE68A",
          padding: "16px 24px",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="#D97706"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"></path>
            <line x1="12" y1="9" x2="12" y2="13"></line>
            <line x1="12" y1="17" x2="12.01" y2="17"></line>
          </svg>
          <span
            style={{
              fontWeight: "bold",
              fontSize: "18px",
              color: "#92400E",
            }}
          >
            {title || t("Validation Errors")}
          </span>
        </div>
        <IconButton
          onClick={onClose}
          size="small"
          style={{
            color: "#92400E",
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent
        style={{
          padding: "24px",
          backgroundColor: "#FFFBEB",
        }}
      >
        <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
          {flattenedErrors.map((error, index) => (
            <div
              key={index}
              style={{
                backgroundColor: "#FEF3C7",
                border: "1px solid #FDE68A",
                borderRadius: "8px",
                padding: "12px 16px",
              }}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "6px",
                }}
              >
                <div
                  style={{
                    fontSize: "14px",
                    lineHeight: "1.5",
                    color: "#92400E",
                    fontWeight: "500",
                }}
              >
                  {error.error_code ? `${error.error_code}: ` : ""}
                  {error.error_message}
                </div>
                {error.error_date && (
                  <div
                    style={{
                      fontSize: "12px",
                      color: "#B45309",
                      fontWeight: "600",
                    }}
                  >
                    {t("Date")}: {error.error_date}
                  </div>
                )}
                {error.value_string && (
                  <div
                    style={{
                      fontSize: "13px",
                      color: "#B45309",
                      fontFamily: "monospace",
                      backgroundColor: "#FDE68A",
                      padding: "4px 8px",
                      borderRadius: "4px",
                      wordBreak: "break-all",
                    }}
                  >
                    {t("Value")}: {error.value_string}
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default ValidationErrorModal;
